export default __webpack_public_path__ + "static/media/healthcare.42df4273.jpg";